import { Button, Card, Space, Tooltip, Tag } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonComponent from "../../fields/ButtonComponent";
import SearchComponent from "../../fields/SearchComponent";
import SwalComponent from "../../fields/SwalComponent";
import TableComponent from "../../fields/TableComponent";
import {
    getSubscriptionList,
    addSubscription,
    getSubscriptionData,
    updateSubscription,
    subscriptionStatus,
    deleteSubscription
} from "../../store/reducer/subscriptionSlice";
import PageHeader from "../../view/pageheader";
import Loader from "../../fields/loader/Loader";

const Subscription = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    //Selectors
    const {
        subscriptionListData,
        subscriptionListLoading,
        deleteSubscriptionLoading,
        deleteSubscriptionSuccess,
        deleteSubscriptionError,
        deleteSubscriptionErrorMessage,
        subscriptionStatusLoading,
        subscriptionStatusSuccess,
        subscriptionStatusError,
        subscriptionStatusErrorMessage,
    } = useSelector(state => state.subscription);
    const { count: totalCount, data: tableData } = subscriptionListData;
    console.log(subscriptionListData, 'subscriptionListData');

    function getData(payload = {}) {
        console.log(payload, 'payload');
        dispatch(getSubscriptionList(payload));
    }

    useEffect(() => {
        getData({});

        if (deleteSubscriptionSuccess) {
            toast.success("Subscription deleted successfully");
        }

        if (deleteSubscriptionError) {
            toast.error(deleteSubscriptionErrorMessage);
        }

        if (subscriptionStatusSuccess) {
            toast.success("Subscription status updated successfully");
        }

        if (subscriptionStatusError) {
            toast.error(subscriptionStatusErrorMessage);
        }
    }, [deleteSubscriptionError, deleteSubscriptionSuccess, subscriptionStatusSuccess, subscriptionStatusError]);

    const columns = [
        {
            title: "Plan",
            key: "plan_name",
            align: "center",
            render: record => record.plan_name
        },
        {
            title: "No. of Properties",
            dataIndex: "max_properties",
            key: "max_properties",
            align: "center",
        },
        {
            title: "No. of Room Items",
            dataIndex: "max_items",
            key: "max_items",
            align: "center",
        },
        {
            title: "Plan Price",
            // dataIndex: "plan_price",
            key: "plan_price",
            align: "center",
            render: record => {
                return record.plan_type == 'free' ? <Tag color="green">Free Plan</Tag> : record.plan_price + ' $';
            }
        },
        {
            title: "Validity",
            key: "validity",
            align: "center",
            render: record => record.validity + ' Days'
        },
        {
            title: "Status",
            key: "status",
            align: "center",
            render: record => (
                <SwalComponent
                    message="Are you sure you want to change the plan status?"
                    onClickDispatch={subscriptionStatus}
                    id={record.id}
                    status={true}
                    statusValue={record.status}
                    postData={{ status: record.status === 1 ? 0 : 1, updateID: record.id }}
                />
            ),
        },
        {
            title: "Action",
            align: "center",
            render: (record) => {
                // Render only the edit action
                return (
                    <Space size="large" align="center">
                        <span className="fs-6" style={{ color: "blue", cursor: "pointer" }}>
                            <Tooltip title="Edit">
                                <i
                                    className="icon-pencil"
                                    onClick={() => {
                                        console.log(record, "record");
                                        navigate(`/subscription/editplan/${btoa(record?.id)}`);
                                    }}
                                ></i>
                            </Tooltip>
                        </span>
                    </Space>
                );
            },
        },
    ];

    return (
        <div>
            <Loader loading={subscriptionListLoading || deleteSubscriptionLoading || subscriptionStatusLoading} />
            <div className="container-fluid">
                <PageHeader HeaderText="Subscription Plans" Breadcrumb={[{ name: "Subscription Plans" }]} />
                <Card
                    title="Subscription Plans"
                    extra={
                        <Space size={"middle"} className="my-3">
                            <SearchComponent
                                placeHolder="Search Plan"
                                onChange={e => {
                                    const payloadData = {
                                        query: e.target.value,
                                    };
                                    getData(payloadData);
                                }}
                            />
                            <Link to="/subscription/addplan">
                                <ButtonComponent
                                    style={{ backgroundColor: "#f7931e", color: "white" }}
                                    onClick={null}
                                    buttonName="Add Subscription Plan"
                                    icon={<i className="fa fa-list-alt" aria-hidden="true"></i>}
                                />
                            </Link>
                        </Space>
                    }
                >
                    <TableComponent
                        columns={columns}
                        dataSource={tableData}
                        TotalDataCount={totalCount}
                        onChangeDispatch={getData}
                    />
                </Card>
            </div>
        </div>
    );
};

export default Subscription;